export default function Terms() {
  return (
    <div className="py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white dark:text-pure-white mb-8">
          moldClaw 이용약관
        </h1>

        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p className="text-gray-500 dark:text-gray-400 mb-8">시행일: 서비스 오픈일</p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제1조 (목적)
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              이 약관은 moldClaw(이하 "회사")가 제공하는 moldClaw 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임 사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제2조 (정의)
            </h2>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-2">
              <li><strong>"서비스"</strong>란 회사가 제공하는 moldClaw 웹사이트(moldclaw.com), moldClaw 데스크톱 애플리케이션, 관련 API 및 부가 서비스를 의미합니다.</li>
              <li><strong>"이용자"</strong>란 이 약관에 동의하고 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
              <li><strong>"회원"</strong>이란 회사에 개인정보를 제공하여 회원 등록을 한 자로서, 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</li>
              <li><strong>"입력(Inputs)"</strong>이란 이용자가 서비스에 제출하는 텍스트, 파일, 이미지, 음성 등 모든 형식의 데이터를 의미합니다.</li>
              <li><strong>"출력(Outputs)"</strong>이란 서비스가 이용자의 입력에 대해 생성하는 응답을 의미합니다.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제3조 (약관의 게시 및 개정)
            </h2>
            <ul className="list-decimal pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-2">
              <li>회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면 또는 연결 화면에 게시합니다.</li>
              <li>회사는 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
              <li>회사가 약관을 개정할 경우에는 적용일자 및 개정 사유를 명시하여 <strong>7일 전</strong>부터 공지합니다. 이용자에게 불리한 약관 개정의 경우에는 <strong>30일 전</strong>부터 공지합니다.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제4조 (회원가입)
            </h2>
            <ul className="list-decimal pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-2">
              <li>이용자는 회사가 정한 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
              <li><strong>연령 제한</strong>: 서비스를 이용하려면 <strong>만 14세 이상</strong>이어야 합니다.</li>
              <li><strong>미성년자(만 19세 미만)</strong>: 유료 서비스를 이용하려면 <strong>법정대리인의 동의</strong>가 필요합니다.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제5조 (사업자 정보)
            </h2>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <table className="w-full text-sm">
                <tbody className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium w-1/3">상호</td>
                    <td className="py-2">주식회사 스페이스바 (SPACEBAR Corp.)</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium">대표자</td>
                    <td className="py-2">김정우</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium">주소</td>
                    <td className="py-2">서울특별시 구로구 디지털로34길 43, 405호내 4229호</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium">이메일</td>
                    <td className="py-2">support@moldclaw.com</td>
                  </tr>
                  <tr className="border-b border-border-gray dark:border-zinc-700">
                    <td className="py-2 font-medium">사업자등록번호</td>
                    <td className="py-2">362-86-01764</td>
                  </tr>
                  <tr>
                    <td className="py-2 font-medium">통신판매업 신고번호</td>
                    <td className="py-2">1763-7025-9329-1185</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제6조 (서비스의 제공)
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-4">회사는 다음의 서비스를 제공합니다:</p>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1">
              <li>moldClaw 데스크톱 애플리케이션 다운로드 및 업데이트</li>
              <li>회원 계정 관리</li>
              <li>AI 모델 API 연동 서비스</li>
              <li>API 키 관리 및 자동 연결</li>
              <li>클라우드 동기화 서비스 (유료)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제7조 (서비스 이용 제한)
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-4">이용자는 다음 행위를 해서는 안 됩니다:</p>
            <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1">
              <li>타인의 정보 도용 또는 타인으로 가장하는 행위</li>
              <li>회사 및 제3자의 저작권 등 지적재산권 침해</li>
              <li>경쟁 제품 또는 서비스 개발에 서비스를 이용하는 행위</li>
              <li>AI 또는 머신러닝 모델 훈련에 서비스를 이용하는 행위</li>
              <li>서비스를 역공학, 디컴파일, 디스어셈블하는 행위</li>
              <li>관련 법령에 위반되는 행위</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제8조 (AI 서비스의 한계)
            </h2>
            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
              <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 font-medium mb-2">⚠️ 중요</p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1 text-sm">
                <li>출력(Outputs)이 항상 정확하지 않을 수 있습니다.</li>
                <li>작업(Actions)이 오류 없이 또는 의도한 대로 작동하지 않을 수 있습니다.</li>
                <li>출력이나 작업의 정확성을 독립적으로 확인하지 않고 의존해서는 안 됩니다.</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제10조 (청약철회 및 환불)
            </h2>
            <ul className="list-decimal pl-6 text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-2">
              <li>이용자는 구독 또는 결제일로부터 <strong>7일 이내</strong>에 청약을 철회할 수 있습니다.</li>
              <li>환불은 <strong>3영업일 이내</strong>에 처리됩니다.</li>
              <li>환불은 원칙적으로 결제 시 사용한 동일한 결제 수단으로 처리합니다.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제12조 (면책조항)
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-4">
              서비스는 <strong>"있는 그대로(AS IS)"</strong> 및 <strong>"이용 가능한 상태로(AS AVAILABLE)"</strong> 제공됩니다.
            </p>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              회사의 총 배상 책임은 해당 손해 발생일 이전 <strong>6개월간 이용자가 회사에 지불한 금액</strong> 또는 <strong>100,000원</strong> 중 큰 금액을 초과하지 않습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              제16조 (분쟁 해결)
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-4">
              이 약관은 <strong>대한민국 법률</strong>에 따라 해석되고 적용됩니다.
            </p>
            <div className="bg-gray-100 dark:bg-zinc-800 dark:bg-zinc-800 rounded-lg p-4">
              <p className="text-sm font-medium text-gray-700 dark:text-gray-300 dark:text-zinc-400 mb-2">분쟁 조정 기관:</p>
              <ul className="text-sm text-gray-700 dark:text-gray-300 dark:text-zinc-400 space-y-1">
                <li>• 한국소비자원: 1372 / www.kca.go.kr</li>
                <li>• 한국인터넷진흥원: 118 / www.kisa.or.kr</li>
                <li>• 전자거래분쟁조정위원회: 1661-5714 / www.ecmc.or.kr</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white dark:text-pure-white mb-4">
              부칙
            </h2>
            <p className="text-gray-700 dark:text-gray-300 dark:text-zinc-400">
              이 약관은 <strong>서비스 오픈일</strong>부터 시행합니다.
            </p>
          </section>

          <div className="border-t border-border-gray dark:border-zinc-700 pt-8 mt-8">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              <strong>주식회사 스페이스바 (SPACEBAR Corp.)</strong><br />
              서비스명: moldClaw<br />
              문의: support@moldclaw.com<br />
              개인정보 관련: privacy@moldclaw.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
